import React from 'react'
import DCHLogo from './DCH-Logo.svg'
import humiSVG from './humi.svg'
import cartSVG from './cart.svg'
import mapSVG from './map.svg'
import sadHumiSVG from './sad-humi.svg'
import closeSVG from './close.svg'
import isabellaSm from './onboarding-isabela-sm.svg'
import isabellaLg from './onboarding-isabela-lg.svg'
import humiLg from './onboarding-humi.svg'
import holeHumi from './humi-hole.svg'
import donutHumi from './humi-donut.png'
import humiSm from './humiSm.svg'
import linktLogo from './LinktLogo.svg'
import forgetPWLogo from './forgetPWHumi.png'

import checkbox from './animations/checkbox.json'
import selectOneButton from './animations/selectOneButton.json'

export const humi = humiSVG
export const humiS = humiSm
export const sadHumi = sadHumiSVG
export const close = closeSVG
export const cart = cartSVG
export const map = mapSVG
export const isabellaS = isabellaSm
export const isabellaL = isabellaLg
export const humiL = humiLg
export const noAnnouncementsHumi = holeHumi
export const noActivitiesHumi = donutHumi
export const DCH = DCHLogo
export const forgetHumi = forgetPWLogo
export const emailIcon = require('./email.png')
export const linktPhones = require('./hero-img.png')

export const linkt = linktLogo

export const check = className => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='23'
      height='18'
      viewBox='0 0 23 18'
      className={className}>
      <path
        fillRule='evenodd'
        d='M8 12.032L4.495 8.505A2.115 2.115 0 0 0 1.5 8.5a2.12 2.12 0 0 0 0 3L8 17.997 21.501 4.5a2.121 2.121 0 0 0 0-3 2.12 2.12 0 0 0-3 .002L8 12.032z'
      />
    </svg>
  )
}
export const closeIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'>
      <path
        fillRule='evenodd'
        d='M9 6.299l5.74-5.74a1.91 1.91 0 0 1 2.7 2.701L11.702 9l5.74 5.74a1.91 1.91 0 0 1-2.701 2.7L9 11.702l-5.74 5.74a1.91 1.91 0 0 1-2.7-2.701L6.298 9 .559 3.26A1.91 1.91 0 1 1 3.26.56L9 6.298z'
      />
    </svg>
  )
}

export const uploadIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='25'
      viewBox='0 0 20 25'>
      <path
        fill='#FFF'
        fillRule='evenodd'
        d='M12.047 7.758v11.327a2.04 2.04 0 1 1-4.08 0V7.745l-4.484 4.392a2.062 2.062 0 0 1-2.885 0 1.978 1.978 0 0 1 0-2.826L9.974.125 10 .151l.026-.026 9.376 9.186a1.978 1.978 0 0 1 0 2.826 2.062 2.062 0 0 1-2.885 0l-4.47-4.38zM1.504 22h17a1.5 1.5 0 1 1 0 3h-17a1.5 1.5 0 0 1 0-3z'
      />
    </svg>
  )
}

export const icons = {
  upload: uploadIcon()
}



// WEBPACK FOOTER //
// ./src/assets/assets.js